// apps/client/src/components/layout/AuthLayout.tsx (CORRECTED TYPESCRIPT)

import React from 'react';

// Define the component's props, explicitly including 'children' to fix the build error
interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }: any) => {
  return (
    <div className="min-h-screen bg-gray-900 flex justify-center items-center p-4">
      {children}
    </div>
  );
};

export default AuthLayout;